import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { firebaseConnect } from 'react-redux-firebase'

import * as Partials from './partials'
import * as UI from '../components'
import { formatCoin, dataToArray } from '../helpers'

export class InvoiceSidebar extends React.Component {
  render() {
    const { purchase, location } = this.props
    const { submitting } = location.state || {}

    return (
      <div>
        <UI.Card>
          <UI.Text uppercase color="accent">
            {purchase && 'Awaiting Payment'}
            {!purchase &&
              (submitting ? 'Creating reservation' : 'Retrieving reservation')}
          </UI.Text>

          <UI.Divider />

          <UI.Text center size="small">
            {purchase &&
              'We are awaiting your funds. The page will auto-update as soon as they are detected.'}
            {!purchase &&
              (submitting
                ? 'We are creating your reservation. The page will auto-update as soon as it is ready.'
                : 'We are retrieving your reservation details. The page will auto-update as soon as it is found.')}
          </UI.Text>

          {purchase &&
            purchase.payments && (
              <div>
                <UI.Divider hidden />

                <Partials.PaymentsList
                  payments={dataToArray(purchase.payments)}
                />
              </div>
            )}

          {purchase &&
            purchase.completedPayments &&
            purchase.completedPayments > 0 && (
              <div>
                <UI.Divider hidden />

                <UI.Progress
                  active
                  progress
                  color="primary"
                  percent={Math.ceil(
                    purchase.completedPayments / purchase.cost * 100
                  )}
                  label={`${formatCoin(
                    purchase.cost - purchase.completedPayments,
                    purchase.currency
                  )} remaining`}
                />
              </div>
            )}
        </UI.Card>
      </div>
    )
  }
}

const watches = props => []

const selectors = createStructuredSelector({})

export default compose(connect(selectors), firebaseConnect(watches))(
  InvoiceSidebar
)



// WEBPACK FOOTER //
// ./src/screens/InvoiceSidebar.js